const flights = {
  flight: "Voo", // translated
  flights: "Voos", // translated
  originDepartureDate: "Partida", // translated
  destinationDepartureDate: "Retornar", // translated
  outbound: "Saída", // translated
  inbound: "Entrada", // translated
  travelTime: "Tempo de viagem", // translated
  selected: "selecionado", // translated
  select: "selecione", // translated
  airline: "CIA aérea", // translated
  directFlight: "Voo direto", // translated
  baggage: "Bagagem", // translated
  stops: "Paradas", // translated
  nonStop: "Sem parar", // translated
  oneStopMax: "Uma parada no máximo", // translated
  twoStopsMax: "Duas paradas no máximo", // translated
  anyStops: "Com qualquer parada", // translated
  smallBaggage: "Bagagem pequena", // translated
  bigBaggage: "Grande bagagem", // translated
  smallAndBigBaggage: "Bagagem pequena e grande", // translated
  outboundStops: "Paradas de saída", // translated
  inboundStops: "Paradas de entrada", // translated
  selectAirline: "Selecione a companhia aérea", // translated
  baggageOption: "Opção de bagagem", // translated
  outboundDepartureAfter: "Saída após", // translated
  outboundArrivalAfter: "Chegada de saída depois", // translated
  inboundDepartureAfter: "Partida de entrada depois", // translated
  inboundArrivalTimeAfter: "Chegada de entrada depois", // translated
  flightClass: "Classe de vôo", // translated
  outboundDepAfter: "Saída depois", // translated
  outboundArrivalAfrer: "Chegada depois", // translated
  inboundDepAfter: "Na partida depois", // translated
  inboundArrivalAfter: "Na chegada depois", // translated
  airlines: "Companhia(s) Aérea(s)", // translated
  lessThan: "Menor que", // translated
  layover: "Escala", // translated
  duration: "Duração", // translated
  economy: "Economia", // translated
  business: "Negócios", // translated
  with: "Com", // translated
  without: "Sem", // translated
  twoOrMore: "Dois ou mais", // translated
  departure: "Partida", // translated
  return: "Retornar", // translated
  submit: "Enviar", // translated
  priceLessThan: "Preço menor que", // translated
  durationLessThan: "Duração inferior a", // translated
  layoverLessThan: "Escala menor que", // translated
  noLayover: "Sem escala", // translated
  durationLowestFirst: "Duração (menor primeiro)", // translated
  durationHighestFirst: "Duração (maior primeiro)", // translated
  idType: "Tipo de identificação", // translated
  idPassportCode: "Código de identificação/passaporte", // translated
  expirationDate: "Data de validade", // translated
  frequentFlyerNumber: "Número de passageiro frequente", // translated
  frequentFlyerAirline: "Companhia aérea de passageiro frequente", // translated
  dateOfBirth: "Data de nascimento", // translated
  infant: "Infantil", // translated
  phone: "Telefone", // translated
  title: "Título", // translated
  noLuggageIncluded: "Sem bagagem incluída", // translated
  includesLuggage: "Inclui bagagem", // translated
  outboundFlight: "Voo de ida", // translated
  inboundFlight: "Voo entrada", // translated
  flightNumber: "Número do vôo", // translated
  flightNumbers: "Números de voo", // translated
  cabinClassType: "Tipo de classe de cabine", // translated
  aircraftType: "Tipo de avião", // translated
  airlineName: "Nome da companhia aérea", // translated
  no: "Não", // translated
  yes: "Sim", // translated
  anyFlights: "Qualquer voo", // translated
  oneStop: "Uma parada", // translated
  direct: "Direto", // translated
  directFlights: "Voos diretos", // translated
  all: "Todos", // translated
  first: "Primeiro", // translated
  premiumEconomy: "Primeiro. Economia", // translated
  withBaggageOnly: "Somente com bagagem", // translated
  oneWay: "Mão Única", // translated
  roundTrip: "Ida e volta", // translated
  withBaggage: "Com bagagem", // translated
  noBaggage: "Sem bagagem", // translated
  requiredFields: "Os campos obrigatórios", // translated
  nonRequiredFields: "Campos não obrigatórios", // translated
  cabinClass: "Classe de cabine", // translated
  brandName: "Marca", // translated
  performNewSearch: "Faça uma nova pesquisa", // translated
  outboundDeparture: "Partida de saída", // translated
  inboundDeparture: "Partida de entrada", // translated
  created: "Criada", // translated
  freeCancellationAvailable: "Cancelamento gratuito disponível", // translated
  freeCancellationDeadline: "Prazo de cancelamento gratuito", // translated
  externalReference: "Referência externa", // translated
  outboundflightNumber: "Número do voo de saída", // translated
  inboundflightNumber: "Número do voo de entrada", // translated
  arrival: "Chegada", // translated
};


export default flights;
